import { useEffect, useState } from 'react';
import { truncateText } from '@/lib';
import { getEnvVariables } from '@/constants/getEnvVariables';


export const ProductsAvailablePage = () => {
  const { API_URL: apiUrl } = getEnvVariables();
  const [dataProductosDisponibles, setDataProductosDisponibles] = useState([]);
  const maxLength = 100;

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(apiUrl + "/maquina/stockproductos/116", {
      headers: { Authorization: "Bearer " + token },
    })
    .then((response) => response.json())
    .then((data) => {
      setDataProductosDisponibles(data.data);
    });
  }, [apiUrl]);


  return (
    <div id="productosHome" className="container my-5">
      <div className="row border border-1 inter-regular text-black p-2 font14 mb-5 d-flex justify-content-between">
        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
          <div className="text-start"><a href="/Home">Perfumes &#187;</a> <a href="todosProductos.html">Silk &#187;</a></div>
        </div>
        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
          <div className="text-end">
            <i className="bi bi-geo-alt-fill"></i> Santiago, Providencia, Manuel Montt 3030
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-lg-2">
          <h4 className="text-start prompt-bold text-black mb-3">Categorias </h4>
        </div>

        <div className="col-12 col-lg-10 d-flex justify-content-center">
          <div className="row">
            {dataProductosDisponibles.map((productoDisponible) => (
              <div key={productoDisponible.producto_id} className="col-12 col-lg-4 mb-5">

                <div id={productoDisponible.producto_id} className="card border-0">
                  <img className="border shadow rounded p-2 img-fluid" src={productoDisponible.producto_foto} alt={productoDisponible.producto_nombre} style={{ maxHeight: '292px', maxWidth: '292px' }} />

                  <div className="card-body" >
                    <h6 className="card-title text-decoration-none text-black montserrat-ultrabold">{productoDisponible.producto_nombre}</h6>
                    <p className="montserrat-regular text-black text" style={{ height: '80px' }}>
                      {truncateText(productoDisponible.producto_descripcion, maxLength)}
                    </p>
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="text-black montserrat-ultrabold">$ {productoDisponible.producto_precio}</span> <a href={`/producto/${productoDisponible.producto_id}`} className="btn border rounded-pill border-dark"><i className="fa-solid fa-cart-shopping"></i> Agregar al Carrito</a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
};